/* eslint-disable @typescript-eslint/no-unsafe-assignment -- Required because error telemetry may receive unknown error shapes from window events */
"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

import {
  getErrorTelemetry,
  logManageTripsEvent,
} from "@jb-manage-trips/fe-logger/manage-trips-events";

/**
 * Global client-side error telemetry.
 *
 * This captures:
 * - window.onerror
 * - unhandled promise rejections
 *
 * DO NOT add PII to telemetry payloads.
 */
export default function ErrorTelemetry(): null {
  const pathname = usePathname();

  useEffect(() => {
    function handleError(event: ErrorEvent): void {
      const error = event.error ?? event;

      const telemetry = getErrorTelemetry(error);

      logManageTripsEvent({
        ...telemetry,
        eventName: "javascript_error",
        feature: "global",
        flow: "global",
        operation: "javascript_error",
        status: "failure",
      });
    }

    function handleRejection(event: PromiseRejectionEvent): void {
      const telemetry = getErrorTelemetry(event.reason);

      logManageTripsEvent({
        ...telemetry,
        eventName: "javascript_error",
        feature: "global",
        flow: "global",
        operation: "javascript_error",
        status: "failure",
      });
    }

    globalThis.addEventListener("error", handleError);
    globalThis.addEventListener("unhandledrejection", handleRejection);

    return () => {
      globalThis.removeEventListener("error", handleError);
      globalThis.removeEventListener("unhandledrejection", handleRejection);
    };
  }, [pathname]);

  return null;
}
/* eslint-enable @typescript-eslint/no-unsafe-assignment */
